import { render, staticRenderFns } from "./FileSetting.vue?vue&type=template&id=27effdde&scoped=true&lang=pug&"
import script from "./FileSetting.vue?vue&type=script&lang=js&"
export * from "./FileSetting.vue?vue&type=script&lang=js&"
import style0 from "./FileSetting.vue?vue&type=style&index=0&id=27effdde&prod&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27effdde",
  null
  
)

export default component.exports